module.exports = __webpack_public_path__ + "img/need.59ede5cb.png";